import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import CountryService from '../../../../Services/CountryService';
import ErrorMessage from '../../../ErrorMessage';

export default class CountrySelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    // Mirrors CountryMultiChoice: choose what the selected value represents. Defaults keep the
    // historical behaviour (the numeric countryId); set one flag to select by code or by name.
    useCountryCode: false,
    useCountryName: false,
    onChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  populateListData() {
    CountryService.GetCountryList()
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.forEach((country) => {
          if (!country.name.includes('DO NOT USE')) {
            const value = this.props.useCountryCode
              ? country.code
              : this.props.useCountryName
              ? country.name
              : country.countryId;
            optValues.push({ label: country.name, value: value, disabled: false });
          }
        });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('COS36');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
